module.exports = {
    STATEMENTS_TYPES_TO_SEND: [
        'Solidarios',
        '0107',
        '0008',
        '0006'
    ],
}
